<box class="trx-details-container" formName="TransferHistoryDetail">

	<ng-container>
		<div>

			<div class="trx-info-list">

				<div class="trx-info" *ngIf="state.popupData?.inventoryNumber">
					<div class="info-feild">
						<span class="lbl"> Reference </span>
						<span class="val" *ngIf="state.popupData?.serviceCode =='EASIPAY'">{{ state.popupData?.inventoryNumber?.substring(state.popupData?.inventoryNumber?.length-12) }} </span>
						<span class="val" *ngIf="state.popupData?.serviceCode !='EASIPAY'">{{ state.popupData?.inventoryNumber?.substring(state.popupData?.inventoryNumber?.length-6) }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.authOn">
					<div class="info-feild">
						<span class="lbl"> Payment Date </span>
						<span class="val">{{ state.popupData?.createdOn }} </span>
                        <!-- <span class="val">{{state.popupData?.authOn |  dateFormatter: "dd/mm/yyyy" }}</span> -->
						<!-- <span class="val">{{ state.popupData?.authOn | date: "dd/MM/yyyy" }} </span> -->
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.debitFrom">
					<div class="info-feild">
						<span class="lbl"> Debit Account</span>
						<span class="val">{{ state.popupData?.debitFrom }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.serviceCode =='EASIPAY' && state.popupData?.mobileNumber">
					<div class="info-feild">
						<span class="lbl"> Meter Number </span>
						<span class="val">{{ state.popupData?.mobileNumber }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.serviceCode =='EASIPAY' && state.popupData?.receipt">
					<div class="info-feild">
						<span class="lbl"> Receipt </span>
						<span class="val">{{ state.popupData?.receipt }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.serviceCode =='EASIPAY' && state.popupData?.unitsIssued">
					<div class="info-feild">
						<span class="lbl"> Units </span>
						<span class="val">{{ state.popupData?.unitsIssued }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.serviceCode !='EASIPAY' && state.popupData?.mobileNumber">
					<div class="info-feild">
						<span class="lbl"> Mobile Number </span>
						<span class="val">{{ state.popupData?.mobileNumber }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.serviceCode !='EASIPAY' && state.popupData?.provider">
					<div class="info-feild">
						<span class="lbl"> Service Provider </span>
						<span class="val">{{ state.popupData?.provider }} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.serviceCode !='EASIPAY' && state.popupData?.nickname">
					<div class="info-feild">
						<span class="lbl"> Nick Name </span>
						<span class="val">{{ state.popupData?.nickname }} </span>
					</div>
				</div>
			

				<!-- <div class="trx-info">
					<div class="info-feild">
						<ng-container *ngIf="state.popupData?.serviceCode =='PAYTOPAYID'">
							<span class="lbl"> PayId</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.serviceCode !='PAYTOPAYID'">
							<span class="lbl"> Credit Account</span>
						</ng-container>
						<span class="val">{{ state.popupData?.creditAccount }} </span>
					</div>
				</div> -->
				<!-- <span class="val">{{ (state.popupData?.beneName).substring(0,3)+ -->
									<!-- "*****"+(state.popupData?.beneName).slice(-3) }} </span> -->

				<div class="trx-info" *ngIf="state.popupData?.amount">
					<div class="info-feild">
						<span class="lbl"> Payment Amount</span>
						<span class="val">
							<span class="amount">
								{{ state.popupData?.amount | currency: state.popupData?.paymentCurrency:"" }}
								<em class="currency"> {{ state.popupData?.paymentCurrency || "PGK" }}</em>
							</span>
						</span>
					</div>

				</div>

				
				<div class="trx-info" *ngIf="state.popupData?.status">
					<div class="info-feild">
						<span class="lbl">Status</span>
						<ng-container *ngIf="state.popupData?.status  ==='S'">
							<span class="val">Success</span>
						</ng-container>
						
						<ng-container *ngIf="state.popupData?.status  !=='S'">
							<span class="val">Failed</span>
						</ng-container>

						<!-- <ng-container *ngIf="state.popupData?.status =='I'">
							<span class="val">Initiated</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.status =='P'">
							<span class="val">Pending</span>
						</ng-container> -->
					</div>
				</div>
				
					<div class="trx-info" *ngIf="state.popupData?.serviceCode =='EASIPAY' && state.popupData?.vouchers">
					<div class="info-feild">
						<span class="lbl"> Voucher </span>
						<span style="white-space: pre-wrap;"
						class="val">{{ state.popupData?.vouchers}} </span>
					</div>
				</div>

				<div class="trx-info" *ngIf="state.popupData?.endDate">
					<div class="info-feild">
						<span class="lbl">End Date</span>
						<span class="val">{{ state.popupData?.endDate | date: "dd/MM/yyyy" }} </span>
					</div>
				</div>

			</div>
		</div>
	</ng-container>

	<ng-template #loader>
		<div class="data-loading">
			<img src="./assets/images/data-loader.svg" alt="loading..." />
		</div>
	</ng-template>
</box>